export default __webpack_public_path__ + "static/media/overviewBannerMobile.a1298f94.png";